<div class="main-content" [ngStyle]="{ direction: pageDirection }">
  <div class="m-box">
    <h2>
      {{ "appointments.gui.labels.appointment_stats.Appointments Stats" | translate }}
    </h2>

    <!-- Tabs -->
    <div class="flex flex-wrap lgw-5_6 xlw-11_12">
      <label class="t-label-top py-4">
        <input
          type="radio"
          name="tab"
          class="custom-check"
          [(ngModel)]="tab"
          (ngModelChange)="onTabChange()"
          value="Scheduled Appointments"
        />
        <i class="customInput-display"></i>
        <span style="font-size: large">
          {{ "appointments.gui.labels.appointment_stats.Scheduled Appointments" | translate }}
        </span>
      </label>

      <label class="t-label-top py-4" style="margin-inline-start: 1.5rem">
        <input
          type="radio"
          name="tab"
          class="custom-check"
          [(ngModel)]="tab"
          (ngModelChange)="onTabChange()"
          value="Completed Appointments"
        />
        <i class="customInput-display"></i>
        <span style="font-size: large">
          {{ "appointments.gui.labels.appointment_stats.Completed Appointments" | translate }}
        </span>
      </label>

      <label class="t-label-top py-4" style="margin-inline-start: 1.5rem">
        <input
          type="radio"
          name="tab"
          class="custom-check"
          [(ngModel)]="tab"
          (ngModelChange)="onTabChange()"
          value="Not Completed Appointments"
        />
        <i class="customInput-display"></i>
        <span style="font-size: large">
          {{ "appointments.gui.labels.appointment_stats.Not Completed Appointments" | translate }}
        </span>
      </label>

      <label *ngIf="loginService.premissions?.ApptsByRoom" class="t-label-top py-4" style="margin-inline-start: 1.5rem">
        <input
          type="radio"
          name="tab"
          class="custom-check"
          [(ngModel)]="tab"
          (ngModelChange)="onTabChange()"
          value="Room Planning"
        />
        <i class="customInput-display"></i>
        <span style="font-size: large">
          {{ "appointments.gui.labels.appointment_stats.Room Planning" | translate }}
        </span>
      </label>
    </div>

    <hr />

    <!-- ================== Room Planning tab ================== -->
    <div *ngIf="tab === 'Room Planning'" class="search-results">
      <div class="flex flex-wrap gap-4 items-end mb-4" style="align-items: flex-end;">

        <!-- Room selector -->
        <div>
          <strong class="nowrap m-r-0-3">
            {{ "appointments.gui.labels.appointment_stats.room_planning.Room" | translate }}:
          </strong>
          <select [(ngModel)]="roomPlanningRID" class="t-field" style="min-width: 14rem;">
            <option [ngValue]="null" disabled>
              {{ "appointments.gui.labels.appointment_stats.room_planning.SelectRoom" | translate }}
            </option>
            <option *ngFor="let room of loginService.rooms" [ngValue]="room.AutoIndex">
              {{ room.RoomName }}
            </option>
          </select>
        </div>

        <!-- From date -->
        <div class="nowrap">
          <strong class="m-r-0-5"> {{ "appointments.gui.labels.From" | translate }}: </strong>
          <input
            [matDatepicker]="rpFromPicker"
            [(ngModel)]="roomPlanningFromDate"
            class="t-field t-field--date menstural-field date-input"
            (click)="rpFromPicker.open()"
          />
          <mat-datepicker #rpFromPicker></mat-datepicker>
        </div>

        <!-- To date -->
        <div class="nowrap">
          <strong class="m-r-0-5"> {{ "appointments.gui.labels.Until" | translate }}: </strong>
          <input
            [matDatepicker]="rpToPicker"
            [(ngModel)]="roomPlanningToDate"
            class="t-field t-field--date menstural-field date-input"
            (click)="rpToPicker.open()"
          />
          <mat-datepicker #rpToPicker></mat-datepicker>
        </div>

        <!-- Search button -->
        <button
          [disabled]="!roomPlanningRID || !roomPlanningFromDate || !roomPlanningToDate || roomPlanningLoading"
          mat-button color="primary" class="blue-btn"
          (click)="searchRoomPlanning()"
        >
          {{ "appointments.gui.labels.appointment_stats.Search" | translate }}
        </button>
      </div>

      <!-- Loader -->
      <ng-container *ngIf="roomPlanningLoading">
        <div style="width: 100%; display: flex; justify-content: center; padding: 2em 0;">
          <img style="width: 30%; margin: 0 2em;" src="../../assets/images/Wedges.svg" />
        </div>
      </ng-container>

      <!-- Results -->
      <ng-container *ngIf="!roomPlanningLoading && roomPlanningResult">
        <hr />
        <!-- Summary cards -->
        <div style="display: flex; gap: 2em; flex-wrap: wrap; margin-bottom: 1.5em;">
          <span>
            {{ "appointments.gui.labels.appointment_stats.room_planning.TotalSlots" | translate }}:
            <strong>{{ roomPlanningResult.totalSlots }}</strong>
          </span>
          <span>
            {{ "appointments.gui.labels.appointment_stats.room_planning.Scheduled" | translate }}:
            <strong>{{ roomPlanningResult.scheduledAppointments }}</strong>
          </span>
          <span>
            {{ "appointments.gui.labels.appointment_stats.room_planning.FreeSlots" | translate }}:
            <strong>{{ roomPlanningResult.freeSlots }}</strong>
          </span>
          <span>
            {{ "appointments.gui.labels.appointment_stats.room_planning.Utilization" | translate }}:
            <strong>{{ roomPlanningResult.utilizationPct }}%</strong>
          </span>
        </div>

        <!-- Daily breakdown table -->
        <div class="mat-elevation-z8" *ngIf="roomPlanningResult.dailyBreakdown.length">
          <table mat-table [dataSource]="roomPlanningResult.dailyBreakdown" style="width:100%">
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>{{ "appointments.gui.labels.appointment_stats.room_planning.Date" | translate }}</th>
              <td mat-cell *matCellDef="let row">{{ row.date }}</td>
            </ng-container>
            <ng-container matColumnDef="availableSlots">
              <th mat-header-cell *matHeaderCellDef>{{ "appointments.gui.labels.appointment_stats.room_planning.TotalSlots" | translate }}</th>
              <td mat-cell *matCellDef="let row">{{ row.availableSlots }}</td>
            </ng-container>
            <ng-container matColumnDef="scheduledAppointments">
              <th mat-header-cell *matHeaderCellDef>{{ "appointments.gui.labels.appointment_stats.room_planning.Scheduled" | translate }}</th>
              <td mat-cell *matCellDef="let row">{{ row.scheduledAppointments }}</td>
            </ng-container>
            <ng-container matColumnDef="freeSlots">
              <th mat-header-cell *matHeaderCellDef>{{ "appointments.gui.labels.appointment_stats.room_planning.FreeSlots" | translate }}</th>
              <td mat-cell *matCellDef="let row" [style.color]="row.freeSlots > 0 ? '#d9534f' : 'inherit'">{{ row.freeSlots }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="['date','availableSlots','scheduledAppointments','freeSlots']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['date','availableSlots','scheduledAppointments','freeSlots']"></tr>
          </table>
        </div>
      </ng-container>

      <div *ngIf="!roomPlanningLoading && roomPlanningResult && roomPlanningResult.dailyBreakdown.length === 0 && roomPlanningResult.totalSlots === 0" class="py-4" style="text-align: center">
        {{ "appointments.gui.labels.appointment_stats.No results available" | translate }}
      </div>
    </div>

    <!-- ================== Controls (shared) ================== -->
    <div *ngIf="tab !== 'Room Planning'" class="search-results">
      <div class="flex gap-4 items-center mb-4 search-controls-wrap">
        <div class="search-controls">
          <!-- Date range -->
          <div class="date-range">
            <strong class="nowrap m-r-0-3">
              {{ "appointments.gui.labels.appointment_stats.Appointment Date" | translate }}
            </strong>
            <div class="nowrap">
              <strong class="m-r-0-5"> {{ "appointments.gui.labels.From" | translate }}: </strong>
              <input
                [matDatepicker]="fromPicker"
                [(ngModel)]="filterFromDate"
                class="t-field t-field--date menstural-field date-input"
                (click)="fromPicker.open()"
              />
              <mat-datepicker #fromPicker></mat-datepicker>
            </div>

            <div class="nowrap">
              <strong class="m-r-0-5"> {{ "appointments.gui.labels.Until" | translate }}: </strong>
              <input
                [matDatepicker]="toPicker"
                [(ngModel)]="filterToDate"
                (click)="toPicker.open()"
                class="t-field t-field--date menstural-field date-input"
              />
              <mat-datepicker #toPicker></mat-datepicker>
            </div>
            <!-- Exam Types -->
            <div class="exam-types">
              <label>
                <strong>
                  {{ "appointments.gui.labels.appointment_stats.Exam Types" | translate }}:
                </strong>
              </label>
              <select
                [(ngModel)]="examTypeFilter"
                (ngModelChange)="onExamTypeChange()"
                class="t-field"
                style="min-width: 12rem"
              >
                <option *ngFor="let opt of examTypeOptions" [ngValue]="opt.value">
                  {{ opt.label }}
                </option>
              </select>
            </div>
          </div>

          <!-- View + Source filters -->
          <div class="flex flex-wrap lgw-5_6 xlw-11_12">
            <div class="created-by">
              <label>
                <strong>
                  {{ "appointments.gui.labels.appointment_stats.Created By" | translate }}:
                </strong>
              </label>

              <label class="t-label-top py-4">
                <input
                  type="radio"
                  name="Filter"
                  class="custom-check"
                  [(ngModel)]="view"
                  (ngModelChange)="onViewChange()"
                  value="All"
                />
                <i class="customInput-display"></i>
                <span style="font-size: large">
                  {{ "appointments.gui.labels.appointment_stats.All" | translate }}
                </span>
              </label>

              <label class="t-label-top py-4" style="margin-inline-start: 1.5rem">
                <input
                  type="radio"
                  name="Filter"
                  class="custom-check"
                  [(ngModel)]="view"
                  (ngModelChange)="onViewChange()"
                  value="Secretary"
                />
                <i class="customInput-display"></i>
                <span style="font-size: large">
                  {{ "appointments.gui.labels.appointment_stats.Secretary" | translate }}
                </span>
              </label>

              <label class="t-label-top py-4" style="margin-inline-start: 1.5rem">
                <input
                  type="radio"
                  name="Filter"
                  class="custom-check"
                  [(ngModel)]="view"
                  (ngModelChange)="onViewChange()"
                  value="Patient"
                />
                <i class="customInput-display"></i>
                <span style="font-size: large">
                  {{ "appointments.gui.labels.appointment_stats.Patient" | translate }}
                </span>
              </label>
            </div>

            <!-- Source filter: visible for All/Patient only -->
            <div
              *ngIf="view !== 'Secretary'"
              style="margin-inline-start: 1.5rem; display: flex; align-items: center; gap: 0.5rem"
            >
              <label>
                <strong> {{ "appointments.gui.labels.appointment_stats.Source" | translate }}: </strong>
              </label>
              <select
                [(ngModel)]="sourceFilter"
                (ngModelChange)="onSourceChange()"
                class="t-field"
                style="min-width: 12rem"
              >
                <option *ngFor="let opt of sourceOptions" [ngValue]="opt.value">
                  {{ "appointments.gui.labels.appointment_stats." + opt.label | translate }}
                </option>
              </select>
            </div>

            <!-- Fund filter -->
            <div style="margin-inline-start: 1.5rem; display: flex; align-items: center; gap: 0.5rem">
              <label>
                <strong> {{ "appointments.gui.labels.Payer" | translate }}: </strong>
              </label>
              <select
                [(ngModel)]="fundFilter"
                (ngModelChange)="onFundChange()"
                class="t-field"
                style="min-width: 12rem"
              >
                <option *ngFor="let opt of fundOptions" [ngValue]="opt.value">
                  {{ opt.label }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="actions">
          <!-- Search -->
          <div style="margin: 0 2em; display: flex">
            <button
              [disabled]="!filterFromDate || !filterToDate || loading"
              mat-button
              color="primary"
              class="blue-btn"
              (click)="searchAppointmetns()"
            >
              {{ "appointments.gui.labels.appointment_stats.Search" | translate }}
            </button>
            <button
              [disabled]="loading"
              mat-button
              color="warn"
              class="orange-btn"
              (click)="clearDateFilter()"
            >
              {{ "appointments.gui.labels.appointment_stats.Clear" | translate }}
            </button>
          </div>
          <!-- Export -->
          <div>
            <button [disabled]="!totalAppts || loading">
              <img
                [ngClass]="!totalAppts || loading ? 'disabled' : ''"
                [matTooltip]="'appointments.gui.tooltips.Download CVS' | translate"
                (click)="exportExcel()"
                height="31em"
                width="31em"
                src="../../assets/icons/fileblue.svg"
              />
            </button>
          </div>
        </div>
      </div>

      <hr *ngIf="hasResults" />

      <!-- ================== Stats (shared) ================== -->
      <div *ngIf="hasResults" class="stats-row" style="display: flex; gap: 2em; flex-wrap: wrap">
        <span>
          {{ "appointments.gui.labels.appointment_stats.Total" | translate }}:
          <strong>{{ totalAppts }}</strong>
        </span>
        <span>
          {{ "appointments.gui.labels.appointment_stats.By Secretary" | translate }} ({{
            "appointments.gui.labels.appointment_stats.per page" | translate
          }}):
          <strong>{{ stats.secretary }}</strong>
        </span>
        <span>
          {{ "appointments.gui.labels.appointment_stats.By Patient" | translate }} ({{
            "appointments.gui.labels.appointment_stats.per page" | translate
          }}):
          <strong>{{ stats.patient }}</strong>
        </span>
        <span>
          {{ "appointments.gui.labels.appointment_stats.By Patient" | translate }} ({{
            "appointments.gui.labels.appointment_stats.WhatsApp" | translate
          }}) ({{ "appointments.gui.labels.appointment_stats.per page" | translate }}):
          <strong>{{ stats.patientWhatsapp }}</strong>
        </span>
        <span>
          {{ "appointments.gui.labels.appointment_stats.By Patient" | translate }} ({{
            "appointments.gui.labels.appointment_stats.Clinic Site" | translate
          }}) ({{ "appointments.gui.labels.appointment_stats.per page" | translate }}):
          <strong>{{ stats.patientClinicSite }}</strong>
        </span>
        <span>
          {{ "appointments.gui.labels.appointment_stats.By Patient" | translate }} ({{
            "appointments.gui.labels.appointment_stats.Direct" | translate
          }}) ({{ "appointments.gui.labels.appointment_stats.per page" | translate }}):
          <strong>{{ stats.patientDirect }}</strong>
        </span>
      </div>

      <hr />

      <!-- ================== Loader ================== -->
      <ng-container *ngIf="loading">
        <div style="width: 100%; display: flex; justify-content: center; padding: 2em 0;">
          <img style="width: 30%; margin: 0 2em 0 2em;" src="../../assets/images/Wedges.svg" />
        </div>
      </ng-container>

      <!-- ================== Table (shared) ================== -->
      <div class="mat-elevation-z8" *ngIf="!loading && hasResults">
        <table mat-table [dataSource]="filteredAppointments" [dir]="pageDirection" matSort (matSortChange)="onMatSort($event)">
          <!-- Index -->
          <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let row; let i = index">
              {{ pageIndex * pageSize + i + 1 }}
            </td>
          </ng-container>

          <!-- Appointment Time -->
          <ng-container matColumnDef="aptTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="aptTime">
              {{ "appointments.gui.labels.appointment_stats.table.Appointment Time" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row.aptTime | date : "dd.MM.yyyy HH:mm" }}</td>
          </ng-container>

          <!-- Creation Time -->
          <ng-container matColumnDef="createdDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="createdDate">
              {{ "appointments.gui.labels.appointment_stats.table.Creation Time" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row.createdDate | date : "dd.MM.yyyy HH:mm" }}</td>
          </ng-container>

          <!-- Patient ID -->
          <ng-container matColumnDef="patientID">
            <th mat-header-cell *matHeaderCellDef>
              {{ "appointments.gui.labels.appointment_stats.table.Patient ID" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row.patientID }}</td>
          </ng-container>

          <!-- Doctor (present when displayedColumns contains 'doctorName') -->
          <ng-container matColumnDef="doctorName">
            <th mat-header-cell *matHeaderCellDef>
              {{ "appointments.gui.labels.appointment_stats.table.Doctor" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row.doctorName || "-" }}</td>
          </ng-container>

          <!-- Room (present when displayedColumns contains 'roomName') -->
          <ng-container matColumnDef="roomName">
            <th mat-header-cell *matHeaderCellDef>
              {{ "appointments.gui.labels.appointment_stats.table.Room" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row.roomName || "-" }}</td>
          </ng-container>

          <!-- Length -->
          <ng-container matColumnDef="aptlength">
            <th mat-header-cell *matHeaderCellDef>
              {{ "appointments.gui.labels.appointment_stats.table.Length (min)" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row.aptlength }}</td>
          </ng-container>

          <!-- Source (present when displayedColumns contains 'visitSource') -->
          <ng-container matColumnDef="visitSource">
            <th mat-header-cell *matHeaderCellDef>
              {{ "appointments.gui.labels.appointment_stats.table.Source" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ sourceLabel(row.visitSource) }}</td>
          </ng-container>

          <!-- Exam -->
          <ng-container matColumnDef="examType">
            <th mat-header-cell *matHeaderCellDef>
              {{ "appointments.gui.labels.appointment_stats.table.Exam Type" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row.examType }}</td>
          </ng-container>

          <!-- Funding (Kupa/Private) -->
          <ng-container matColumnDef="funding">
            <th mat-header-cell *matHeaderCellDef>
              {{ "appointments.gui.labels.Payer" | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              [style.color]="isFundingMismatch(row) ? '#d9534f' : 'inherit'"
            >
              {{ fundingLabel(row) }}
            </td>
          </ng-container>

          <!-- Exam Code (entered by patient when booking) -->
          <ng-container matColumnDef="examCode">
            <th mat-header-cell *matHeaderCellDef>
              {{ "appointments.gui.labels.Exam Code" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row.examCode || "-" }}</td>
          </ng-container>

          <!-- Created By -->
          <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef>
              {{ "appointments.gui.labels.appointment_stats.table.Created By" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ createdByLabel(row) }}</td>
          </ng-container>

          <!-- Exam Status -->
          <ng-container matColumnDef="ExamStatus">
            <th mat-header-cell *matHeaderCellDef style="direction: initial;">TodayList סטטוס</th>
            <td mat-cell *matCellDef="let row">{{ row.ExamStatus || '-' }}</td>
          </ng-container>

          <!-- Completed -->
          <ng-container matColumnDef="completed">
            <th mat-header-cell *matHeaderCellDef>סומן כבוצע</th>
            <td mat-cell *matCellDef="let row">{{ row.completed ? 'כן' : 'לא' }}</td>
          </ng-container>

          <!-- Status -->
          <!-- <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">{{ row.Status || "-" }}</td>
          </ng-container> -->

          <!-- Last Update -->
          <ng-container matColumnDef="LastUpdate">
            <th mat-header-cell *matHeaderCellDef>
              {{ "appointments.gui.labels.appointment_stats.table.Last Update" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.LastUpdate ? (row.LastUpdate | date : "dd.MM.yyyy HH:mm") : "-" }}
            </td>
          </ng-container>

          <!-- Header/Row defs driven by displayedColumns -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"></tr>
        </table>

        <!-- MatPaginator (server-side) -->
        <mat-paginator
          [length]="totalAppts"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [pageSizeOptions]="[25, 50, 100]"
          [dir]="pageDirection"
          showFirstLastButtons
          (page)="onMatPage($event)"
          aria-label="Appointment pages"
        >
        </mat-paginator>
      </div>

      <div *ngIf="!loading && !hasResults" class="py-4" style="text-align: center">
        {{ "appointments.gui.labels.appointment_stats.No results available" | translate }}
      </div>
    </div>
    <!-- ================== /Controls + Table (shared) ================== -->
  </div>
</div>
